//Author June Leow
//Date Mar 22nd, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Col, Row, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import {NavLink} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const condoCarStorageTypeEnum = [
  {value:'ATTACHED_GARAGE', label:'Attached Garage'}, 
  {value:'DETACHED_GARAGE', label:'Detached Garage'}, 
  {value:'BUILTIN_GARAGE', label:'Built in Garage'}, 
  {value:'CARPORT', label:'Carport'}, 
  {value:'OPEN_UNASSIGNED', label:'Open Unassigned'}, 
  {value:'OPEN_ASSIGNED', label:'Open Assigned'}
];

const condoCarStorageDeficienciesNameEnum = [
  {value:'NONE_OBSERVED', label:'None Observed'}, 
  {value:'SIDING', label:'Siding'}, 
  {value:'WINDOWS', label:'Windows'}, 
  {value:'DOORS', label:'Doors'}, 
  {value:'GARAGE_DOOR', label:'Garage Door'}, 
  {value:'EXTERIOR_WALLS', label:'Exterior Walls'}, 
  {value:'INTERIOR_WALLS', label:'Interior Walls'}, 
  {value:'CEILING', label:'Ceiling'}, 
  {value:'ROOF', label:'Roof'}, 
  {value:'FOUNDATION', label:'Foundation'}, 
  {value:'OTHER', label:'Other'}, 
];

const condoCarStorageDeficienciesTypeEnum = [
  {value:'EXCESSIVE_WEAR', label:'Excessive Wear'}, 
  {value:'EVIDENCE_OF_INFESTATION', label:'Evidence of Infestation'}, 
  {value:'MISSING', label:'Missing'}, 
  {value:'OTHER', label:'Other'}
];

const condoCarStorageDeficiencyDetailFoundationEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'}, 
  {value:'CRACKING', label:'Cracking'}, 
  {value:'SETTLEMENT', label:'Settlement'}, 
  {value:'EVIDENCE_OF_MOISTURE', label:'Evidence of Moisture'}, 
  {value:'SEEPAGE', label:'Seepage'}, 
  {value:'INFESTATION', label:'Infestation'}, 
  {value:'LEANING_OR_BOWED_WALLS', label:'Leaning or Bowed Walls'}, 
  {value:'HEAVING', label:'Heaving'}, 
  {value:'OTHER', label:'Other'}, 
];

const condoCarStorageDeficiencyDetailExteriorWallsEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'}, 
  {value:'CRACKING', label:'Cracking'}, 
  {value:'HOLES', label:'Holes'}, 
  {value:'DRY_ROT', label:'Dry Rot'}, 
  {value:'MOISTURE_ROT', label:'Moisture Rot'}, 
  {value:'SETTLEMENT', label:'Settlement'}, 
  {value:'WIND_DAMAGE', label:'Wind Damage'}, 
  {value:'MISSING_MATERIAL', label:'Missing Material'}, 
  {value:'OTHER', label:'Other'}, 
];

const condoCarStorageDeficiencyDetailRoofSurfaceEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'}, 
  {value:'CRACKING', label:'Cracking'}, 
  {value:'TARP_ON_ROOF', label:'Tarp On Roof'}, 
  {value:'LEAK_EVIDENT', label:'Leak Evident'}, 
  {value:'MISSING_MATERIAL', label:'Missing Material'}, 
  {value:'WOOD_ROT', label:'Wood Rot'}, 
  {value:'SOFFIT_DAMAGE', label:'Soffit Damage'}, 
  {value:'FASCIA_DAMAGE', label:'Fascia Damage'}, 
  {value:'OTHER', label:'Other'}
];

const condoCarStorageDeficiencyDetailWindowsEnum = [
  {value:'CRACKING', label:'Cracking'}, 
  {value:'MISSING_WINDOW_PANE', label:'Missing Window Pane'}, 
  {value:'EXPOSED_WOOD', label:'Exposed Wood'}, 
  {value:'STORM_SASH_DAMAGE', label:'Storm Sash Damage'}, 
  {value:'THERMOPANE_DAMAGE', label:'Thermopane Damage'}, 
  {value:'OTHER', label:'Other'}, 
];

const condoCarStorageDeficiencyDetailCeilingEnum = [
  {value:'DISCOLORATION', label:'Discoloration'}, 
  {value:'MISSING', label:'Missing'}, 
  {value:'CRUMBLING', label:'Crumbling'}, 
  {value:'WATER_DAMAGE', label:'Water Damage'}, 
  {value:'OTHER', label:'Other'}, 
];

const condoCarStorageDeficiencyDetailInteriorWallsEnum = [
  {value:'DISCOLORATION', label:'Discoloration'}, 
  {value:'MISSING', label:'Missing'}, 
  {value:'CRUMBLING', label:'Crumbling'}, 
  {value:'WATER_DAMAGE', label:'Water Damage'}, 
  {value:'OTHER', label:'Other'}, 
];

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const CondoCarStorage  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const numberOnly= (e) => {
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key);
    if (!isControlKey && e.key.match(/[^0-9]/)) {
      e.preventDefault();
    }
  };
  
  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let condoCarStorages = newUPD.property.buildings[props.index].condoCarStorages.slice();
   
                let target = condoCarStorages[index][field]?condoCarStorages[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:condoCarStorages[index].ID, description:description});
                condoCarStorages[index][field] = target;
                newUPD.property.buildings[props.index].condoCarStorages = condoCarStorages;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop2 = (acceptedFiles, rejectedFiles, index, index2, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let carStoragesDeficiencies = newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies.slice()
   
                let target = carStoragesDeficiencies[index2][field]?carStoragesDeficiencies[index2][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:carStoragesDeficiencies[index2].ID, description:description});
                carStoragesDeficiencies[index2][field] = target;
                newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateFileDescription = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let condoCarStorages = newUPD.property.buildings[props.index].condoCarStorages.slice();
    let target = condoCarStorages[index][field]?condoCarStorages[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].condoCarStorages = condoCarStorages;
    props.update(newUPD);
  }

  const updateFileDescription2 = (index, index2, index3, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let carStoragesDeficiencies = newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies.slice()
    let target = carStoragesDeficiencies[index2][field]?carStoragesDeficiencies[index2][field]:[];
  
    if(target &&  target[index3]){
      target[index3].description = description;
    }

    newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
    props.update(newUPD);
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let condoCarStorages = newUPD.property.buildings[props.index].condoCarStorages.slice();
    let target = condoCarStorages[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        condoCarStorages[index][field] = target;
        newUPD.property.buildings[props.index].condoCarStorages = condoCarStorages;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      condoCarStorages[index][field] = target;
      newUPD.property.buildings[props.index].condoCarStorages = condoCarStorages;
      props.update(newUPD);
    }
  }

  const removeFile2 = (field,index, index2, index3)=>{
    let newUPD = Object.assign({}, props.upd);
    let carStoragesDeficiencies = newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies.slice()
    let target = carStoragesDeficiencies[index2][field].slice();

    let targetToDelete = target[index3];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index3, 1);
        carStoragesDeficiencies[index2][field] = target;
        newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index3, 1);
      carStoragesDeficiencies[index2][field] = target;
      newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
      props.update(newUPD);
    }
  }

  const getCondoCarStorageDeficienciesNameLabel = (value)=>{
    for(let i=0;i<condoCarStorageDeficienciesNameEnum.length;i++){
      if(condoCarStorageDeficienciesNameEnum[i].value===value)
        return condoCarStorageDeficienciesNameEnum[i].label;
    }

    return value;
  }

  const getCondoCarStorageDeficiencyDetailLabel = (value, type)=>{
    let detailEnum = [];

    if(type === 'foundation'){
      detailEnum = condoCarStorageDeficiencyDetailFoundationEnum;
    }else if(type === 'exterior walls'){
      detailEnum = condoCarStorageDeficiencyDetailExteriorWallsEnum;
    }else if(type === 'roof surface'){
      detailEnum = condoCarStorageDeficiencyDetailRoofSurfaceEnum;
    }else if(type === 'interior walls'){
      detailEnum = condoCarStorageDeficiencyDetailInteriorWallsEnum;
    }else if(type === 'ceiling'){
      detailEnum = condoCarStorageDeficiencyDetailCeilingEnum;
    }else if(type === 'windows'){
      detailEnum = condoCarStorageDeficiencyDetailWindowsEnum;
    }
    console.log(detailEnum);
    console.log("|"+value+"|")
    for(let i=0;i<detailEnum.length;i++){
      if(detailEnum[i].value===value)
        return detailEnum[i].label;
    }

    return value;
  }

  const updateCondoStorageDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let condoCarStorages = newUPD.property.buildings[props.index].condoCarStorages.slice();
    condoCarStorages[index][field] = value;
    newUPD.property.buildings[props.index].condoCarStorages = condoCarStorages;
    props.update(newUPD);
  }

  const updateCondoStorageDeficiencies = (index, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let carStoragesDeficiencies = newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies?newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies.slice():[];
    
    if(value==='NONE_OBSERVED'){
      carStoragesDeficiencies = [{condoCarStorageDeficiencyName:value, imageCondoCarStorageDeficiency:[]}];
    }
    else{
      for(let i=0;i<carStoragesDeficiencies.length;i++){
        if(carStoragesDeficiencies[i].condoCarStorageDeficiencyName==='NONE_OBSERVED'){
          carStoragesDeficiencies = [];
          break;
        }
      }
    
      carStoragesDeficiencies.push({condoCarStorageDeficiencyName:value, imageCondoCarStorageDeficiency:[]});
    }
    
    newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
    props.update(newUPD);
  }

  const updateCondoStorageDeficienciesDetail = (index, index2, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let carStoragesDeficiencies = newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies?newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies.slice():[];

    switch(field){
      case 'condoCarStorageDeficiencyDetailFoundation':
      case 'condoCarStorageDeficiencyDetailExteriorWalls':
      case 'condoCarStorageDeficiencyDetailRoofSurface':
      case 'condoCarStorageDeficiencyDetailInteriorWalls':
      case 'condoCarStorageDeficiencyDetailCeiling':
      case 'condoCarStorageDeficiencyDetailWindows':
        let target = carStoragesDeficiencies[index2][field]?carStoragesDeficiencies[index2][field].slice():[];
        if(target.indexOf(value)===-1)
          target.push(value);
          carStoragesDeficiencies[index2][field] = target;
        break;
      default:
        carStoragesDeficiencies[index2][field] = value;
        break;
    }

    
    newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
    props.update(newUPD);
  }

  const addCondoCarStorage = ()=>{
    let newUPD = Object.assign({}, props.upd);
    let condoCarStorages = newUPD.property.buildings[props.index].condoCarStorages.slice();
    condoCarStorages.push({imageOutsideGarage:[], imageInsideGarage:[], imageCarport:[], imageOpenAssigned:[]});
    newUPD.property.buildings[props.index].condoCarStorages = condoCarStorages;
    props.update(newUPD);
  }

  const removeCondoCarStorage = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let condoCarStorages = newUPD.property.buildings[props.index].condoCarStorages.slice();
    condoCarStorages.splice(index, 1);
    newUPD.property.buildings[props.index].condoCarStorages = condoCarStorages;
    props.update(newUPD);
  }

  const removeCondoCarStorageDeficiency = (index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let carStoragesDeficiencies = newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies.slice();
    carStoragesDeficiencies.splice(index2, 1);
    newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
    props.update(newUPD);
  }

  const removeCondoStorageDeficienciesDetail = (index, index2, index3, field)=>{
    let newUPD = Object.assign({}, props.upd);
    let carStoragesDeficiencies = newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies.slice();
    let target = carStoragesDeficiencies[index2][field].slice();
    target.splice(index3, 1);
    carStoragesDeficiencies[index2][field] = target;
    newUPD.property.buildings[props.index].condoCarStorages[index].carStoragesDeficiencies = carStoragesDeficiencies;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return (<div>
    {!props.disabled && props.upd.property.propertyType==='CONDO'?<div className="align-right">
      <NavLink to="#" onClick={(e)=>addCondoCarStorage()}><i className="fa fa-plus green-color"/> Add Condo Car Storage</NavLink>
    </div>:null}
    {
      props.upd.property.buildings[props.index].condoCarStorages.map(
        (carStorage, index)=>{
          let offstreetParking;

          if(props.upd.property.buildings[props.index].condoOffstreetParkingAvailable==='True'){
            offstreetParking = <Col sm="6">
            <label>{!props.disabled?<font color="red">*</font>:null}What type of off street parking is available for the subject unit? {generateTooltip('condoCarStorageType'+index, 'If off street parking is selected, indicate the type of garage, whether a carport exists, and/or whether open assigned or unassigned parking is available. If more than one type is available, choose all that apply. ')}</label>
            <MySelect
              type="select"
              required={!props.disabled}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={carStorage.condoCarStorageType}
              onChange={(v)=>updateCondoStorageDetail(index, 'condoCarStorageType', v)}
              options={condoCarStorageTypeEnum}
            />
          </Col>;
          }
          return (
            <div key={index} style={{marginTop:"10px"}}>
              <Card>
                <CardHeader>
                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoCarStorage(index)}/> Condo Car Storage # {index+1}
                </CardHeader>
                <CardBody>
                  <Row>
                    {offstreetParking}
                    <Col sm="6">
                      <label>{!props.disabled?<font color="red">*</font>:null}How many parking spaces are available for this car storage type? {generateTooltip('condoCarStorageSpaceCount'+index, 'Provide the structure\'s total area including finished and unfinished areas. Can be derived mathematically. ')}</label>
                      <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={carStorage.condoCarStorageSpaceCount} onChange={(e)=>updateCondoStorageDetail(index,'condoCarStorageSpaceCount', e.target.value)}/>
                    </Col>
                  </Row>
                  <br/>
                  {carStorage.condoCarStorageType==='BUILTIN_GARAGE'||carStorage.condoCarStorageType==='ATTACHED_GARAGE'||carStorage.condoCarStorageType==='DETACHED_GARAGE'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}Are there any garage item(s) / component(s) with damage or wear that require repairs? {generateTooltip('condoCarStorageType'+index, 'User to identify any garage component(s) that are either damaged or show signs of wear requiring significant repairs. User should select \'None Observed\' if no repairs are needed. ')}</label>
                    <MySelect
                      type="select"
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={carStorage.carStoragesDeficiencies && carStorage.carStoragesDeficiencies.length>0?" ":""}
                      required={!props.disabled}
                      onChange={(v)=>updateCondoStorageDeficiencies(index, v)}
                      options={condoCarStorageDeficienciesNameEnum}
                    />
                    <br/>
                  </div>:null}
                  {
                    carStorage.carStoragesDeficiencies?carStorage.carStoragesDeficiencies.map(
                      (carStoragesDeficiency, index2)=>{
                        if(carStoragesDeficiency.condoCarStorageDeficiencyName==='NONE_OBSERVED'){
                          return <div key={index} style={{marginTop:'15px'}}>
                            <b>None Observed</b>
                          </div>
                        }
                        return <div key={index2}>
                          <Card>
                            <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoCarStorageDeficiency(index, index2)}/>{getCondoCarStorageDeficienciesNameLabel(carStoragesDeficiency.condoCarStorageDeficiencyName)} Damage/Wear Details</CardHeader>
                            <CardBody>
                              <label>{!props.disabled?<font color="red">*</font>:null}What type of damage or wear did you observe? {generateTooltip('condoCarStorageDeficiencyType'+index, 'User to identify the type of deficiency of the item / component selected.')}</label>
                              <MySelect
                                type="select"
                                disabled={props.disabled}
                                style={props.disabled?disabledStyling:{}}
                                required={!props.disabled}
                                value={carStoragesDeficiency.condoCarStorageDeficiencyType}
                                onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencyType', v)}
                                options={condoCarStorageDeficienciesTypeEnum}
                              />
                              <br/>
                              {carStoragesDeficiency.condoCarStorageDeficiencyName==='FOUNDATION'?<div>
                                <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                                <MySelect
                                  type="select"
                                  disabled={props.disabled}
                                  style={props.disabled?disabledStyling:{}}
                                  required={!props.disabled}
                                  value={carStoragesDeficiency.condoCarStorageDeficiencyDetailFoundation && carStoragesDeficiency.condoCarStorageDeficiencyDetailFoundation.length>0?" ":""}
                                  onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencyDetailFoundation', v)}
                                  options={condoCarStorageDeficiencyDetailFoundationEnum}
                                />
                                <br/>
                                {
                                  carStoragesDeficiency.condoCarStorageDeficiencyDetailFoundation?carStoragesDeficiency.condoCarStorageDeficiencyDetailFoundation.map(
                                    (detail, index3)=>{
                                      return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoStorageDeficienciesDetail(index, index2, index3, 'condoCarStorageDeficiencyDetailFoundation')}/> {getCondoCarStorageDeficiencyDetailLabel(detail, 'foundation')}
                                      </span>
                                    }
                                  ):null
                                }
                              </div>:null}

                              {carStoragesDeficiency.condoCarStorageDeficiencyName==='EXTERIOR_WALLS'?<div>
                                <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                                <MySelect
                                  type="select"
                                  disabled={props.disabled}
                                  style={props.disabled?disabledStyling:{}}
                                  required={!props.disabled}
                                  value={carStoragesDeficiency.condoCarStorageDeficiencyDetailExteriorWalls && carStoragesDeficiency.condoCarStorageDeficiencyDetailExteriorWalls.length>0?" ":""}
                                  onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencyDetailExteriorWalls', v)}
                                  options={condoCarStorageDeficiencyDetailExteriorWallsEnum}
                                />
                                <br/>
                                {
                                  carStoragesDeficiency.condoCarStorageDeficiencyDetailExteriorWalls?carStoragesDeficiency.condoCarStorageDeficiencyDetailExteriorWalls.map(
                                    (detail, index3)=>{
                                      return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoStorageDeficienciesDetail(index, index2, index3, 'condoCarStorageDeficiencyDetailExteriorWalls')}/> {getCondoCarStorageDeficiencyDetailLabel(detail, 'exterior walls')}
                                      </span>
                                    }
                                  ):null
                                }
                              </div>:null}

                              {carStoragesDeficiency.condoCarStorageDeficiencyName==='ROOF'?<div>
                                <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                                <MySelect
                                  type="select"
                                  disabled={props.disabled}
                                  required={!props.disabled}
                                  style={props.disabled?disabledStyling:{}}
                                  value={carStoragesDeficiency.condoCarStorageDeficiencyDetailRoofSurface && carStoragesDeficiency.condoCarStorageDeficiencyDetailRoofSurface.length>0?" ":""}
                                  onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencyDetailRoofSurface', v)}
                                  options={condoCarStorageDeficiencyDetailRoofSurfaceEnum}
                                />
                                <br/>
                                {
                                  carStoragesDeficiency.condoCarStorageDeficiencyDetailRoofSurface?carStoragesDeficiency.condoCarStorageDeficiencyDetailRoofSurface.map(
                                    (detail, index3)=>{
                                      return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoStorageDeficienciesDetail(index, index2, index3, 'condoCarStorageDeficiencyDetailRoofSurface')}/> {getCondoCarStorageDeficiencyDetailLabel(detail, 'roof surface')}
                                      </span>
                                    }
                                  ):null
                                }
                              </div>:null}
                              
                              {carStoragesDeficiency.condoCarStorageDeficiencyName==='INTERIOR_WALLS'?<div>
                                <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                                <MySelect
                                  type="select"
                                  disabled={props.disabled}
                                  required={!props.disabled}
                                  style={props.disabled?disabledStyling:{}}
                                  value={carStoragesDeficiency.condoCarStorageDeficiencyDetailInteriorWalls && carStoragesDeficiency.condoCarStorageDeficiencyDetailInteriorWalls.length>0?" ":""}
                                  onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencyDetailInteriorWalls', v)}
                                  options={condoCarStorageDeficiencyDetailInteriorWallsEnum}
                                />
                                <br/>
                                {
                                  carStoragesDeficiency.condoCarStorageDeficiencyDetailInteriorWalls?carStoragesDeficiency.condoCarStorageDeficiencyDetailInteriorWalls.map(
                                    (detail, index3)=>{
                                      return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoStorageDeficienciesDetail(index, index2, index3, 'condoCarStorageDeficiencyDetailInteriorWalls')}/> {getCondoCarStorageDeficiencyDetailLabel(detail, 'interior walls')}
                                      </span>
                                    }
                                  ):null
                                }
                              </div>:null}

                              {carStoragesDeficiency.condoCarStorageDeficiencyName==='CEILING'?<div>
                                <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                                <MySelect
                                  type="select"
                                  disabled={props.disabled}
                                  required={!props.disabled}
                                  style={props.disabled?disabledStyling:{}}
                                  value={carStoragesDeficiency.condoCarStorageDeficiencyDetailCeiling && carStoragesDeficiency.condoCarStorageDeficiencyDetailCeiling.length>0?" ":""}
                                  onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencyDetailCeiling', v)}
                                  options={condoCarStorageDeficiencyDetailCeilingEnum}
                                />
                                <br/>
                                {
                                  carStoragesDeficiency.condoCarStorageDeficiencyDetailCeiling?carStoragesDeficiency.condoCarStorageDeficiencyDetailCeiling.map(
                                    (detail, index3)=>{
                                      return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoStorageDeficienciesDetail(index, index2, index3, 'condoCarStorageDeficiencyDetailCeiling')}/> {getCondoCarStorageDeficiencyDetailLabel(detail, 'ceiling')}
                                      </span>
                                    }
                                  ):null
                                }
                              </div>:null}

                              {carStoragesDeficiency.condoCarStorageDeficiencyName==='WINDOWS'?<div>
                                <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                                <MySelect
                                  type="select"
                                  required={!props.disabled}
                                  disabled={props.disabled}
                                  style={props.disabled?disabledStyling:{}}
                                  value={carStoragesDeficiency.condoCarStorageDeficiencyDetailWindows && carStoragesDeficiency.condoCarStorageDeficiencyDetailWindows.length>0?" ":""}
                                  onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencyDetailWindows', v)}
                                  options={condoCarStorageDeficiencyDetailWindowsEnum}
                                />
                                <br/>
                                {
                                  carStoragesDeficiency.condoCarStorageDeficiencyDetailWindows?carStoragesDeficiency.condoCarStorageDeficiencyDetailWindows.map(
                                    (detail, index3)=>{
                                      return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondoStorageDeficienciesDetail(index, index2, index3, 'condoCarStorageDeficiencyDetailWindows')}/> {getCondoCarStorageDeficiencyDetailLabel(detail, 'windows')}
                                      </span>
                                    }
                                  ):null
                                }
                              </div>:null}

                              <label>{!props.disabled?<font color="red">*</font>:null}Does the deficiency impact the safety, soundness or structural integrity of the structure?</label>
                              <MySelect
                                type="select"
                                required={!props.disabled}
                                disabled={props.disabled}
                                style={props.disabled?disabledStyling:{}}
                                value={carStoragesDeficiency.condoCarStorageDeficiencySeverity}
                                onChange={(v)=>updateCondoStorageDeficienciesDetail(index, index2, 'condoCarStorageDeficiencySeverity', v)}
                                options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                              />
                              <br/>
                              <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of each deficiency observed. {generateTooltip('condoCarStorageDeficiencyDescription'+index2, 'User to provide a concise text description of any deficiencies observed.')}</label>
                              <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={carStoragesDeficiency.condoCarStorageDeficiencyDescription} onChange={(e)=>updateCondoStorageDeficienciesDetail(index,index2,'condoCarStorageDeficiencyDescription', e.target.value)}/>
                              <br/>
                              <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of car storage deficiency {generateTooltip('imageCondoCarStorageDeficiency', 'Image(s) of all garage deficiencies identified. Image type name varies depending on the type of car storage update selected.')}</label>
                              <br/>
                              <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0, width:0 }}
                                value={carStoragesDeficiency.imageCondoCarStorageDeficiency&&carStoragesDeficiency.imageCondoCarStorageDeficiency.length>0?" ":""}
                                required={!props.disabled}
                              />
                              <div>
                                <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, index2, 'imageCondoCarStorageDeficiency', carStoragesDeficiency.condoCarStorageDeficiencyName+'_CARSTORAGE_DEFICIENCY', 0)}} className="my-dropzone">
                                {
                                  ({getRootProps, getInputProps}) => (
                                    <div
                                      {...getRootProps({
                                        className: 'my-dropzone',
                                      })}
                                    >
                                      <input {...getInputProps()} />
                                      <center>Choose files to upload</center>
                                    </div>
                                  )
                                }
                                </Dropzone>
                                {
                                  !carStoragesDeficiency.imageCondoCarStorageDeficiency?null:carStoragesDeficiency.imageCondoCarStorageDeficiency.map(
                                    (photo, index3)=>{
                                      return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                        <div>
                                          <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile2('imageCondoCarStorageDeficiency',index, index2,index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                        </div>
                                        <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                        <div style={{marginTop:'5px'}}/>
                                        {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription2(index, index2, index3, 'imageCondoCarStorageDeficiency', e.target.value)}/>
                                        <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                      </div>
                                    }
                                  )
                                }
                              </div>
                            </CardBody>
                          </Card>
                          <br/>
                        </div>
                      }
                    ):null
                  }

                  {
                    (props.upd.property.buildings[props.index].buildingDesign==='GARDEN'|| props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE') && (carStorage.condoCarStorageType==='BUILTIN_GARAGE'||carStorage.condoCarStorageType==='ATTACHED_GARAGE'||carStorage.condoCarStorageType==='DETACHED_GARAGE')?<div>
                      <Row>
                        <Col sm="6">
                          <label>{!props.disabled && (props.upd.property.buildings[props.index].buildingDesign==='GARDEN'|| props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE') && (carStorage.condoCarStorageType==='BUILTIN_GARAGE'||carStorage.condoCarStorageType==='ATTACHED_GARAGE'||carStorage.condoCarStorageType==='DETACHED_GARAGE')?<font color="red">*</font>:null}Image(s) of outside of garage {generateTooltip('imageOutsideCondoStorage', 'Image(s) of the outside of the garage. Should include the entry door. Note: If the garage was converted to living space, then evidence of this should be captured through this image. At a minimum provide images of the exterior of the garage, showing if the garage entry has been changed or removed. Image type name varies depending upon the name of the garage type.')}</label>
                          <br/>
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0, width:0 }}
                            value={carStorage.imageOutsideGarage&&carStorage.imageOutsideGarage.length>0?" ":""}
                            required={!props.disabled && (props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE') && (carStorage.condoCarStorageType==='BUILTIN_GARAGE'||carStorage.condoCarStorageType==='ATTACHED_GARAGE'||carStorage.condoCarStorageType==='DETACHED_GARAGE')}
                          />
                          <div>
                            <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageOutsideGarage', 'CONDO_'+carStorage.condoCarStorageType+'_EXTERIOR', 0)}} className="my-dropzone">
                            {
                              ({getRootProps, getInputProps}) => (
                                <div
                                  {...getRootProps({
                                    className: 'my-dropzone',
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  <center>Choose files to upload</center>
                                </div>
                              )
                            }
                            </Dropzone>
                            {
                              !carStorage.imageOutsideGarage?null:carStorage.imageOutsideGarage.map(
                                (photo, index2)=>{
                                  return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                    <div>
                                      <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageOutsideGarage',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                    </div>
                                    <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                    <div style={{marginTop:'5px'}}/>
                                    {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageOutsideGarage', e.target.value)}/>
                                    <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                  </div>
                                }
                              )
                            }
                          </div>
                        </Col>
                        <Col sm="6">
                          <label>{!props.disabled && (props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE') && (carStorage.condoCarStorageType==='BUILTIN_GARAGE'||carStorage.condoCarStorageType==='ATTACHED_GARAGE'||carStorage.condoCarStorageType==='DETACHED_GARAGE')?<font color="red">*</font>:null}Image(s) of inside of garage {generateTooltip('imageInsideCondoStorage', 'Image(s) of the inside of the garage. Include images from opposite corners of the interior to ensure adequate coverage. Note: If the garage was converted, then evidence of this should be captured through this image. The interior image should show the level of completion of the converted space. Image type name varies depending upon the name of the garage type.')}</label>
                          <br/>
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0, width:0 }}
                            value={carStorage.imageInsideGarage&&carStorage.imageInsideGarage.length>0?" ":""}
                            required={!props.disabled && (props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE') && (carStorage.condoCarStorageType==='BUILTIN_GARAGE'||carStorage.condoCarStorageType==='ATTACHED_GARAGE'||carStorage.condoCarStorageType==='DETACHED_GARAGE')}
                          />
                          <div>
                            <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageInsideGarage', 'CONDO_'+carStorage.condoCarStorageType+'_INTERIOR', 0)}} className="my-dropzone">
                            {
                              ({getRootProps, getInputProps}) => (
                                <div
                                  {...getRootProps({
                                    className: 'my-dropzone',
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  <center>Choose files to upload</center>
                                </div>
                              )
                            }
                            </Dropzone>
                            {
                              !carStorage.imageInsideGarage?null:carStorage.imageInsideGarage.map(
                                (photo, index2)=>{
                                  return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                    <div>
                                      <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageInsideGarage',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                    </div>
                                    <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                    <div style={{marginTop:'5px'}}/>
                                    {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageInsideGarage', e.target.value)}/>
                                    <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                  </div>
                                }
                              )
                            }
                          </div>
                        </Col>
                      </Row>
                    </div>:null
                  }
                  
                  {carStorage.condoCarStorageType==='CARPORT' && (props.upd.property.buildings[props.index].buildingDesign==='GARDEN'|| props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE')?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of the carport</label>
                    <br/>
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0, width:0 }}
                      value={carStorage.imageCarport&&carStorage.imageCarport.length>0?" ":""}
                      required={!props.disabled}
                    />
                    <div>
                      <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageCarport', 'CARPORT', 0)}} className="my-dropzone">
                      {
                        ({getRootProps, getInputProps}) => (
                          <div
                            {...getRootProps({
                              className: 'my-dropzone',
                            })}
                          >
                            <input {...getInputProps()} />
                            <center>Choose files to upload</center>
                          </div>
                        )
                      }
                      </Dropzone>
                      {
                        !carStorage.imageCarport?null:carStorage.imageCarport.map(
                          (photo, index2)=>{
                            return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                              <div>
                                <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageCarport',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                              </div>
                              <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                              <div style={{marginTop:'5px'}}/>
                              {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageCarport', e.target.value)}/>
                              <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                            </div>
                          }
                        )
                      }
                    </div>
                  </div>:null}

                  {carStorage.condoCarStorageType==='OPEN_ASSIGNED' && (props.upd.property.buildings[props.index].buildingDesign==='GARDEN'|| props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE')?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of assigned parking space</label>
                    <br/>
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0, width:0 }}
                      value={carStorage.imageOpenAssigned&&carStorage.imageOpenAssigned.length>0?" ":""}
                      required={!props.disabled}
                    />
                    <div>
                      <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageOpenAssigned', 'OPEN_ASSIGNED', 0)}} className="my-dropzone">
                      {
                        ({getRootProps, getInputProps}) => (
                          <div
                            {...getRootProps({
                              className: 'my-dropzone',
                            })}
                          >
                            <input {...getInputProps()} />
                            <center>Choose files to upload</center>
                          </div>
                        )
                      }
                      </Dropzone>
                      {
                        !carStorage.imageOpenAssigned?null:carStorage.imageOpenAssigned.map(
                          (photo, index2)=>{
                            return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                              <div>
                                <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageOpenAssigned',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                              </div>
                              <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                              <div style={{marginTop:'5px'}}/>
                              {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageOpenAssigned', e.target.value)}/>
                              <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                            </div>
                          }
                        )
                      }
                    </div>
                  </div>:null}
                </CardBody>
              </Card>
            </div>
          )
        }
      )
    }
    
  </div>);
}


export default CondoCarStorage;